import React from "react";
import { AiFillCaretLeft, AiFillCaretRight } from "react-icons/ai";

function Pagination(props) {
  const { pagination, setpagination, data } = props;
  if (data?.total_pages === 0) {
    return <></>;
  }
  return (
    <div className="d-flex justify-content-between mt-3 mb-3">
      <div>
        {data?.total_count && (
          <div className="pagination">
            <p className="mt-2 mb-0 mx-2 Montserrat">
              Total count: {data?.total_count}
            </p>{" "}
          </div>
        )}
      </div>
      {data?.total_count > 5 && (
        <div className="pagination">
          <div className="d-flex">
            <div className="mt-2 mx-2 Montserrat">
              {pagination} of {data?.total_pages} Pages
            </div>{" "}
            &nbsp;&nbsp;&nbsp;&nbsp;
          </div>
          <div className="d-flex">
            <div
              className={
                data?.prev_page !== 0
                  ? "pagi_icon grey"
                  : "pagi_icon light-grey"
              }
              onClick={() =>
                data?.prev_page !== 0 ? setpagination(pagination - 1) : ""
              }
            >
              <AiFillCaretLeft />
            </div>
            <div
              className={
                data?.next_page !== null
                  ? "pagi_icon grey"
                  : "pagi_icon light-grey"
              }
              onClick={() =>
                data?.next_page !== null ? setpagination(pagination + 1) : ""
              }
            >
              <AiFillCaretRight />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Pagination;
